import { userStore } from "../store";

export const getUserLocale = () => {
  return userStore.locale;
};
